import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentMentionableEffects } from './mentionables/mentionables.effects';
import {
  TellentMentionableNamespace,
  TellentMentionableReducer,
} from './mentionables/mentionables.store';
import { TellentNotesEffects } from './notes/notes.effects';
import { TellentNotesNamespace, TellentNotesReducer } from './notes/notes.store';

export const tellentNotesStoreProvider = provideState(TellentNotesNamespace, TellentNotesReducer);
export const tellentNotesEffectsProvider = provideEffects([TellentNotesEffects]);

export const tellentMentionablesStoreProvider = provideState(
  TellentMentionableNamespace,
  TellentMentionableReducer,
);
export const tellentMentionablesEffectsProvider = provideEffects([TellentMentionableEffects]);
export const provideTellentNotesNgrx = [
  tellentNotesStoreProvider,
  tellentNotesEffectsProvider,
  tellentMentionablesStoreProvider,
  tellentMentionablesEffectsProvider,
];
